import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/user/verify-email"
    exact
    path="/business/user/verify-email"
    component={AsyncPage}
  />,
];
